import { Menu } from "antd";
import styled from "styled-components";

export const StyledCustomerSettingsMenu = styled(Menu)`
  width: 100% !important;
  height: 100% !important;
  border-radius: 16px;
`;
